/**
 * Safely extracts an error message from an axios error response
 * Handles both string and object detail responses
 * @param {Error} error - The axios error object
 * @param {string} fallback - Fallback message if extraction fails
 * @returns {string} - The error message string
 */
export const getErrorMessage = (error, fallback = 'An error occurred') => {
  const detail = error?.response?.data?.detail;
  
  if (!detail) {
    return error?.message || fallback;
  }
  
  // If detail is already a string, return it
  if (typeof detail === 'string') {
    return detail;
  }
  
  // If detail is an object, try to extract the message
  if (typeof detail === 'object') {
    // Check common error object properties
    if (detail.message) return detail.message;
    if (detail.error) return detail.error;
    if (detail.msg) return detail.msg;
    
    // For subscription/AI limit errors
    if (detail.limit && detail.current) {
      return detail.message || `Limit reached: ${detail.current}/${detail.limit}`;
    }
  }
  
  return fallback;
};

export default getErrorMessage;
